import { z } from 'zod';
import { Option } from '../../types/Option';

export type CableScreenType =
    | 'none'
    | 'yes'
    | 'aluminiumPet'
    | 'aluminiumPetDrain'
    | 'copperBraid'
    | 'tinnedCopperBraid'
    | 'copperTape'
    | 'steelWireArmour'
    | 'copperWireScreen'
    | 'tinnedCopperWireScreen'
    | 'foilBraid'
    | 'overall'
    | 'individual'
    | 'individualAndOverall';

const options = [
    { value: 'none', label: 'None' },
    { value: 'yes', label: 'Yes (unspecified type)' },
    { value: 'aluminiumPet', label: 'Aluminium-PET' },
    { value: 'aluminiumPetDrain', label: 'Aluminium-PET with drain wire' },
    { value: 'copperBraid', label: 'Copper braid' },
    { value: 'tinnedCopperBraid', label: 'Tinned copper braid' },
    { value: 'copperTape', label: 'Copper tape' },
    { value: 'steelWireArmour', label: 'Steel wire armour' },
    { value: 'copperWireScreen', label: 'Copper wire screen' },
    { value: 'tinnedCopperWireScreen', label: 'Tinned copper wire screen' },
    { value: 'foilBraid', label: 'Foil + braid' },
    { value: 'overall', label: 'Overall screen' },
    { value: 'individual', label: 'Individual screen' },
    { value: 'individualAndOverall', label: 'Individual and overall screen' },
] as Option<CableScreenType>[];

const validator = z.enum([
    'none',
    'yes',
    'aluminiumPet',
    'aluminiumPetDrain',
    'copperBraid',
    'tinnedCopperBraid',
    'copperTape',
    'steelWireArmour',
    'copperWireScreen',
    'tinnedCopperWireScreen',
    'foilBraid',
    'overall',
    'individual',
    'individualAndOverall',
]);

export const CableScreen = {
    validator,
    options,
};
